export default __webpack_public_path__ + "static/media/instagram-icon-black.10a50f1b.svg";